// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"1bf967ba","453":"8772ac72","461":"595e86a2","942":"dc4e5071"}[chunkId] + ".chunk.js";
};